 
<template>
  <div class="evalbox">
    <div class="box_nav">
      <div class="praise">
        <p class="p_1">好评率</p>
        <p class="p_2">{{evalNum}}%</p>
        <p class="p_3"><i class="el-icon-star-on active"></i><i class="el-icon-star-on active"></i><i class="el-icon-star-on active"></i><i class="el-icon-star-on active"></i><i class="el-icon-star-on active"></i></p>
      </div>
      <div class="sort">
        <p>排序</p>
        <p><span>默认</span></p>
      </div>
    </div>
    <div class="box_main active">
      <div class="left">
        <img src="" />
        <p>用****名</p>
      </div>
      <div class="right">
        <p class="p_1"><i class="el-icon-star-on active"></i><i class="el-icon-star-on active"></i><i class="el-icon-star-on active"></i><i class="el-icon-star-on active"></i><i class="el-icon-star-on active"></i></p>
        <p class="p_2">规格：淡雅灰</p>
        <p class="p_3">评论内容文字可以多行，颜色很漂亮。手感特别好，就是觉得有点儿贵，只买了一个套，如果便宜了，再入手。健康拉家带口垃圾啊快疯了久爱</p>
        <imgEffect :evalImg="imgEval"></imgEffect>
        <div class="time">2019-12-08  16:14:08</div>
      </div>
    </div>
    <div class="box_main">
      <div class="left">
        <img src="" />
        <p>用****名</p>
      </div>
      <div class="right">
        <p class="p_1"><i class="el-icon-star-on active"></i><i class="el-icon-star-on active"></i><i class="el-icon-star-on active"></i><i class="el-icon-star-on active"></i><i class="el-icon-star-on active"></i></p>
        <p class="p_2">规格：淡雅灰</p>
        <p class="p_3">评论内容文字可以多行，颜色很漂亮。手感特别好，就是觉得有点儿贵，只买了一个套，如果便宜了，再入手。健康拉家带口垃圾啊快疯了久爱</p>
        <imgEffect :evalImg="imgEval"></imgEffect>
        <div class="time">2019-12-08  16:14:08</div>
      </div>
    </div>
    <!-- <div class="box_main" v-for="(item, index) in goodEval" :key="index"></div> -->
  </div>
</template>
 
<script>
import imgEffect from "../components/imgEffect";
export default {
  name: "evalbox",
  components: {
    imgEffect
  },
  props: {
    evalNum: {
      type: Number,
      default: 0
    },
    gooodId: {
      type: String,
      default: ""
    },
    goodEval: {
      type: Array,
      default: []
    },
    imgEval: {
      type: Array,
      default: []
    },
  }
};
</script>
<style lang="less" scoped>
.evalbox{
  padding-top: 16px;
  .box_nav{
    width: 100%;
    border-bottom:1px solid rgba(218,218,218,1);
    overflow: hidden;
    .praise{
      float: left;
      width: 180px;
      text-align: center;
      .p_1{
        color: #333;
        padding-bottom: 20px;
      }
      .p_2{
        font-size:46px;
        font-weight:500;
        color:rgba(213,22,28,1);
        line-height:36px;
      }
      .p_3{
        font-size: 0;
        padding-top: 8px;
        overflow: hidden;
        .el-icon-star-on{
          display: inline-block;
          vertical-align: top;
          margin: 0 1px;
          font-size: 20px;
          color: #dadada;
          &.active{
            color: rgba(249,189,79,1);
          }
        }
      }
    }
    .sort{
      float: left;
      width: 1020px;
      height: 48px;
      margin-top: 64px;
      border-top:1px solid rgba(218,218,218,1);
      p,span{
        line-height: 48px;
      }
      p{
        float: left;
        padding: 0 25px;
        span{
          display: block;
          color:rgba(180,160,120,1);
          cursor: pointer;
        }
      }
    }
  }
  .box_main{
    width: 100%;
    padding-top: 40px;
    border-top: dashed 1px rgba(218,218,218,1);
    overflow: hidden;
    &.active{
      border-top-width: 0
    }
    .left{
      float: left;
      width: 80px;
      font-size: 0;
      text-align: center;
      margin-right: 40px;
      img{
        width: 80px;
        height: 80px;
        border-radius: 50%;
      }
      p{
        color:rgba(51,51,51,1);
        padding-top: 16px;
        padding-bottom: 40px;
      }
    }
    .right{
      float: left;
      width: 1040px;
      p{
        float: left;
        width: 100%;
        &.p_1{
          font-size: 0;
          .el-icon-star-on{
            display: inline-block;
            vertical-align: top;
            margin: 0 1px;
            font-size: 20px;
            color: #dadada;
            &.active{
              color: rgba(249,189,79,1);
            }
          }
        }
        &.p_2{
          color: #999;
          padding: 6px 0 3px;
        }
        &.p_3{
          color: #333;
          width: 980px;
          line-height: 24px;
        }
      }
      .time{
        float: left;
        color: #999;
        width: 100%;
        padding: 0 0 40px;
      }
    }
  }
}
</style>